import useAnalyticsSync from '@/app/analytics/useAnalyticsSync';
import useStatsAnalytics from '@/app/analytics/useStatsAnalytics';

export default function AnalyticsSync() {
  useAnalyticsSync();
  useStatsAnalytics();

  return null;
}
